import type { NotificationBasicInfoType } from './notificationBasicInfoType';

export interface NotificationBasicInfo {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  createdAt?: string | null;
  id: number;
  type: NotificationBasicInfoType;
  /** @nullable */
  updatedAt?: string | null;
  userId: number;
}
